var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableSimpleBlock',{attrs:{"title":"Informe control revisiones PIC","items":_vm.picRevisionReportData,"fields":_vm.fields,"isLoading":_vm.isPicRevisionReportLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }